export const PDF_COLORS = {
  // Brand colors
  PRIMARY: '#000000',
  ACCENT: '#006967',
  GECKO_ORANGE: '#E55812',

  // Text colors
  TEXT_PRIMARY: '#000000',
  TEXT_SECONDARY: '#555555',
  TEXT_TERTIARY: '#666666',
  TEXT_LIGHT: '#FFFFFF',
  TEXT_MUTED: '#999999',

  // UI colors
  BACKGROUND_LIGHT: '#FFFFFF',
  BACKGROUND_OFF_WHITE: '#F8F8F8',
  BACKGROUND_LIGHT_GRAY: '#F5F5F5',
  BACKGROUND_GRAY: '#EEEEEE',

  // Border colors
  BORDER_LIGHT: '#DDDDDD',
  BORDER_MEDIUM: '#CCCCCC',

  // Status colors
  ERROR: '#FF0000',
  SUCCESS: '#06D6A0',

  // Gradient colors (used in stripe)
  GRADIENT_START: '#E55812',
  GRADIENT_MID_1: '#EBFF00',
  GRADIENT_MID_2: '#00FF85',
  GRADIENT_MID_3: '#06D6A0',
  GRADIENT_END: '#1B43AA',
}
